import { render, staticRenderFns } from "./MainScreen.vue?vue&type=template&id=48f6bf48"
import script from "./MainScreen.vue?vue&type=script&lang=js"
export * from "./MainScreen.vue?vue&type=script&lang=js"
import style0 from "./MainScreen.vue?vue&type=style&index=0&id=48f6bf48&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports